import { useEffect } from "react";
import type { RouteObject } from "react-router-dom";
import { LoadingIndicator } from "@dealer-center/core-custom-components";
import { PagesInventoryConfigUiDisplay } from "./Display";
import { useGetAccount } from "@dealer-center/ddc-api-account-fetch";

export const PagesInventoryConfigUi = () => {
  const { data: accountEntity } = useGetAccount();
  useEffect(() => {
    document.title = `${accountEntity?.name} - Inventory Config`;
  }, [accountEntity?.name]);
  if (!accountEntity) {
    return (
      <LoadingIndicator
        actionName="Loading inventory configs"
        data-testid="PagesInventoryConfigLoading"
      />
    );
  }
  return <PagesInventoryConfigUiDisplay />;
};

export const InventoryConfigRoute = {
  path: "websiteInventoryConfigs/:selectedConfig?",
  element: <PagesInventoryConfigUi />
} as RouteObject;
